import { useMutation } from '@tanstack/react-query';
import { axiosLicensingInstance } from 'api/axios/licensing';
import { routes } from 'api/routes';

type DeleteCancelPlan = {
  clientId: string;
  paymentMethodId: string;
};

const remove = (values: DeleteCancelPlan) => {
  const { clientId, paymentMethodId } = values;

  return axiosLicensingInstance.delete(
    `${routes['client']}/${clientId}/paymentMethod/${paymentMethodId}`,
  );
};

const useDeletePaymentMethod = () => {
  return useMutation({
    mutationFn: remove,
  });
};

export default useDeletePaymentMethod;
